import { createAction } from '@reduxjs/toolkit';

// TODO: remove later, dummy action
export const initAdmin = createAction<boolean>('INIT_ADMIN');
